<template>
    <div>
      <div class="grid-container">
        <div class="top-half"></div>
        <div class="bottom-half">
          <div class="card-container">
            <CCard class="border-radius-16px p-4 mb-5">
              <div class="text-center">
                <h3 class="custom-40px-700 text-center font-color-064BB4">
                  <img src="../assets/img/status-up-blue.png" style="max-width:48px" class="mr-2" />MyHR Solutions
                </h3>
                <div class="text-left">
                  <img src="../assets/img/arrowback.png" style="max-width:20px" class="text-left" @click="GoBack" />
                  <h4 class="custom-36px-700 font-color-171717 text-left mt-5">Create New Password</h4>
                  <p class="custom-16px-400 text-left">Send your email account to reset password and make new password</p>
                </div>
              </div>
  
              <div v-if="ErrorLogin" class="ml-4 mr-4 mt-4">
                <CAlert show color="danger">
                  <strong class="text-danger mr-2">Error !</strong> {{ Message }}
                </CAlert>
              </div>
              <div class="mt-3">
                <strong class="text-left mt-2 mb-3">Password</strong>
                <CInput type="password" class="mb-2 mt-2" v-model="newPassword" />
                <br />
                <div class="password-strength">
                  <img v-for="index in maxBars" :key="index" :src="index <= currentBars ? barShow : barNotShow" alt="Strength Bar" /> 
                  <label class="custom-12px-500 font-color-33B843" style="margin-top:-10px">Strong</label>
                </div>
                <p class="mt-2">Min 8 Characters with a combination of letters and numbers</p>
                <strong class="text-left mt-2 mb-3">Confirm Password</strong>
                <CInput type="password" class="mb-2 mt-2" v-model="confirmPassword" @input="updatePassword" />
                <br />
              </div>
              <div class="text-center mt-3 mb-4">
                <CButton
                  class="bg-0B63F6 p-2 text-center text-white pr-5 pl-5 border-radius-half"
                  :class="{ 'disabled-button': !isPasswordValid }"
                  @click="ChangePassword"
                  :disabled="!isPasswordValid"
                  block
                >
                  Continue
                </CButton>
              </div>
            </CCard>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  import GAuth from 'vue-google-oauth2';
  
  const gauthOption = {
    clientId: 'YOUR_CLIENT_ID',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
  };
  
  Vue.use(GAuth, gauthOption);
  
  import { Carousel3d, Slide } from "vue-carousel-3d";
  import MarqueeText from "vue-marquee-text-component";
  import AOS from "aos";
  import "aos/dist/aos.css";
  
  Vue.use(Carousel3d);
  Vue.component("marquee-text", MarqueeText);
  
  import backgroundUrl from "../assets/img/bgPurpleYellow.png";
  import Mainlayout from "../containers/AllHeader.vue";
  import Footerlayout from "../containers/TheFooter.vue";
  import ToggleCard from '../components/Toggle.vue';
  Vue.use(VuejsDialog);
  import VuejsDialog from "vuejs-dialog";
  import "vuejs-dialog/dist/vuejs-dialog.min.css";
  
  export default {
    name: "Login",
    components: {
      Carousel3d,
      Slide,
      MarqueeText,
      Mainlayout,
      Footerlayout,
      ToggleCard,
    },
    data() {
      return {
        backgroundUrl,
        newPassword: "",
        confirmPassword: "",
        ErrorLogin: false,
        Message: "",
        barShow: require('../assets/img/barpasswordshow.png'),
        barNotShow: require('../assets/img/barpasswordnotshow.png'),
        maxBars: 4,
        updatePassword: "",
      };
    },
    computed: {
      currentBars() {
        const length = this.newPassword.length;
        if (length >= 8) return this.maxBars;
        if (length >= 6) return 3;
        if (length >= 4) return 2;
        if (length >= 2) return 1;
        return 0;
      },
      isPasswordValid() {
      return this.newPassword.length >= 8 && this.newPassword === this.confirmPassword;
    }
    },
    methods: {
      GoBack() {
        this.$router.push("/");
      },
      ChangePassword() {
        const formData = new FormData();
        formData.append("newPassword", this.newPassword);

        return this.$API
          .post(this.$UpdatePassword, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status === 200) {
              this.$dialog.alert("You have successfully updated new password").then(function() {});
              this.$router.push("/Login");
            }
            else {
              this.ErrorMessage = true;
            }
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.data);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
              this.ErrorMessage = true;
            }
          });
      },

    },
  };
  </script>
  
  <style scoped>
  @import url('https://fonts.cdnfonts.com/css/general-sans');
  body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
  }
  
  .password-strength {
    display: flex;
    width: 100%; /* Full width */
    justify-content: space-between; /* Evenly distribute bars */
    gap: 4px; /* Space between bars */
  }
  
  .password-strength img {
    width: 24%; /* Adjust the width as needed */
    height: 5px;
  }
  </style>
  